import React from 'react'
import { graphql } from 'gatsby'

import { FeatureLanding, Section, Column, PricingTable, UserLogos } from '../components/landing'
import { BulletList, ListItem } from '../components/list'
import Link from '../components/link'

export default ({ data }) => {
    const storeData = data.site.siteMetadata.store
    return (
        <FeatureLanding
            title="Get Prodigy"
            description={
                <>
                    Join <strong>thousands of data scientists and researchers</strong> who are
                    already using Prodigy for radically efficent machine teaching and annotation.
                </>
            }
            large={true}
            blobs={false}
        >
            <PricingTable {...storeData} />
            <Section center>
                <Column title="What’s included">
                    <BulletList>
                        <ListItem>
                            Prodigy installer for Python 3.6+ on macOS / OSX, Linux and Windows.
                        </ListItem>
                        <ListItem>
                            Standalone, self-hosted <strong>annotation back-end</strong> with
                            pluggable architecture.
                        </ListItem>
                        <ListItem>
                            Built-in <Link to="/docs/recipes">annotation recipes</Link> for a{' '}
                            <strong>wide range of machine learning tasks</strong>, including named
                            entity recognition, text classification, part-of-speech tagging,
                            dependency parsing, coreference resolution, computer vision, audio and
                            video annotation, transcription, speaker diarization, training and
                            evaluation, and more.{' '}
                        </ListItem>
                        <ListItem>
                            Customizable <strong>web application</strong> with 19{' '}
                            <Link to="/docs/api-interfaces">annotation interfaces</Link> for text,
                            images, audio, video, relations, multiple-choice, HTML, conflict
                            resolution and more.
                        </ListItem>
                        <ListItem>
                            Active learning models for <strong>named entity recognition</strong>,{' '}
                            <strong>text classification</strong>, part-of-speech tagging and
                            dependency parsing.
                        </ListItem>
                        <ListItem>
                            <strong>Extensive documentation</strong> and access to the{' '}
                            <Link to="https://support.prodi.gy">Prodigy Support Forum</Link>.
                        </ListItem>
                        <ListItem>
                            <strong>Cloud-free:</strong> Prodigy works offline on your own hardware.
                            No data ever needs to leave your servers.
                        </ListItem>
                        <ListItem>
                            <strong>No lock-in:</strong> fully open and extensible data formats and
                            storage solutions.
                        </ListItem>
                        <ListItem>
                            <strong>Lifetime license:</strong> buy once, keep forever and receive 12
                            months of free upgrades.
                        </ListItem>
                    </BulletList>
                </Column>
            </Section>

            <UserLogos />
        </FeatureLanding>
    )
}

export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                store {
                    licenses {
                        id
                        sendowl
                        title
                        subtitle
                        price
                        priceInfo
                        color
                        features
                        renew {
                            title
                            text
                            sendowl
                        }
                    }
                    academic {
                        title
                        subtitle
                        text
                        buttonUrl
                        buttonText
                    }
                }
            }
        }
    }
`
